import { Account } from '@/domain/usecases'
import { UserContentSearch } from '@/domain/usecases/content/user-content-search'
import { parseNumber } from '@/main/helpers/number-helper'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs } from 'react-router-dom'
import SearchLoader from './search-loader'

export default class InstitutionSearchLoader extends SearchLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader({ request, params }: LoaderFunctionArgs) {
    if (params.id === undefined) {
      return this.defer({
        data: undefined
      })
    }

    const url = new URL(request.url)
    const searchParams = this.createSearchParamsByInstitution(params.id, url.searchParams)

    return this.defer({
      data: this.getLoaderPromise(searchParams)
    })
  }

  protected createSearchParamsByInstitution(
    institutionId: string,
    searchParams: URLSearchParams
  ): UserContentSearch.Params {
    const params = super.createSearchParams(searchParams)
    params.institutions = [parseNumber(institutionId)!]
    return params
  }
}
